import { Component, inject, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { CivilStatus } from '../../../../core/enum/civil-status.enum';
import { QuoteStateService } from '../../../../feature/family-shield/state/quote-state.service';
import { BreakdownSection } from '../../../../feature/family-shield/mapper/quote-breakdown.mapper';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.html',
  styleUrl: './quote.scss',
  imports: [DecimalPipe],
})
export class Quote {
  protected state = inject(QuoteStateService);
  private router = inject(Router);

  readonly request = this.state.request;
  readonly totalPremium = this.state.totalPremium;
  readonly breakdown: Signal<BreakdownSection[]> = this.state.breakdown;
  readonly isValid = this.state.isValid;

  isloading = this.state.loading;

  protected readonly CivilStatus = CivilStatus;

  // ===============================
  // CLEAN EVENT HANDLERS
  // ===============================

  onCivilStatusChange(event: Event) {
    const select = event.target as HTMLSelectElement;
    const value = select.value as CivilStatus;

    if (!value) return;

    this.state.setCivilStatus(value);
  }

  onWithChildrenChange(withChildren: boolean) {
    this.state.setWithChildren(withChildren);
  }

  validate() {
    if (!this.isValid()) return;
    this.isloading.set(true);
    setTimeout(() => {
      this.router.navigate(['/family-shield/form']).then(() => this.isloading.set(false));
    }, 1000);

  }
}
